import React, { useState, useEffect, useCallback } from "react";
import Button from "react-bootstrap/Button";
import { Link, Route } from "react-router-dom";
import { FaChartBar, FaSchool, FaTools } from "react-icons/fa";

import Bunexe_service from "../../Bunexe_service";
import ChoixEcole from "./souscomposants/ChoixEcole";
import SaisieNotes from "./souscomposants/SaisieNotes";
import StatsMat_anticipees from "./souscomposants/StatsMat_anticipees";
import SaisieCodeEnregistrement from "./souscomposants/Saisie_CodeEnregistrement";
import ProgressionSaisie from "./souscomposants/ProgressionSaisie";

const Saisie_notes_bac = ({ code_dept, info, mon_ecole }) => {
  const [ecole_selection, setEcole_selection] = useState(mon_ecole);
  const [titre_, setTitre_] = useState("");
  const cheminpush = "/mat_anticipees/ns3";

  const getTitre = useCallback(() => {
    const dept = Bunexe_service.depts.find((d) => d.code == code_dept);
    if (dept) {
      setTitre_(dept.titre);
    }
  }, [code_dept]);

  useEffect(() => {
    getTitre();
  }, [getTitre]);

  return (
    <div className="container-fluid mt-3">
      {titre_ && <h2 className="text-center text-secondary">{titre_}</h2>}
      <h3 className="text-center mb-4">Saisie de Notes Bac - Juillet 2026</h3>

      <div className="d-flex justify-content-center mb-4">
        <Button
          className="bg-info mr-2"
          as={Link}
          to="/saisie_notes_bac/saisie"
          title="Saisie des notes"
        >
          <FaTools size={20} />
        </Button>
        <Button
          className="bg-info mr-2"
          as={Link}
          to="/saisie_notes_bac/saisie_code_enregistrement"
          title="Saisie code d'enregistrement"
        >
          <FaSchool size={20} />
        </Button>
        <Button
          className="bg-info"
          as={Link}
          to="/saisie_notes_bac/progression_saisie"
          title="Progression de la saisie"
        >
          <FaChartBar size={20} />
        </Button>
      </div>

      <Route
        exact
        path="/saisie_notes_bac/saisie"
        render={(props) => (
          <SaisieNotes
            {...props}
            ecole_selection={ecole_selection}
            titre_={titre_}
            info_={info}
          />
        )}
      />
      <Route
        exact
        path="/saisie_notes_bac/saisie_code_enregistrement"
        render={(props) => (
          <SaisieCodeEnregistrement
            {...props}
            ecole_selection={ecole_selection}
            titre_={titre_}
            info_={info}
          />
        )}
      />
      <Route
        exact
        path="/saisie_notes_bac/progression_saisie"
        render={(props) => (
          <ProgressionSaisie
            {...props}
            ecole_selection={ecole_selection}
            titre_={titre_}
            info_={info}
          />
        )}
      />
      <Route
        exact
        path="/mat_anticipees/choix"
        render={() => (
          <ChoixEcole
            setEcole_selection={setEcole_selection}
            code_dept={code_dept}
            cheminpush={cheminpush}
          />
        )}
      />
      <Route
        exact
        path="/mat_anticipees/stat"
        render={() => (
          <StatsMat_anticipees code_dept={code_dept} titre_={titre_} />
        )}
      />
    </div>
  );
};

export default Saisie_notes_bac;
